import { app, Component } from 'apprun';
import { agent, agency } from './api';
import { __ } from './Txlat';
import { getId, getAgentLink, add_meta, add_link, set_title, setDetailLanguageLink } from './utility';
import PropertyListing from './propertyListing';
import AgentAbout from './agentAbout';
import Charts from './charts';
import AgentDetailProfile from './template/agent-detail-profile-template';
import InquiryForm from './inquiry-form';
import InqueryTitle from './agent-inquiry-title';

class agentDetailProfile extends Component {
  view = (state) => {
    return (<AgentDetailProfile agent={state.agent} agency={state.agency} />);
  };

  update = {
    '#': async (state) => {

      state.id = getId();
      state.agent = await agent.getAgentByID(state.id);

      const agent_url = getAgentLink(state.agent);

      if (window.location.pathname !== encodeURI(agent_url)) {
        window.location.href = agent_url;
        return;
      }
      state.agent.isCommercailAgent = true;
      state.properties = await agent.getAllAgentProperties(state.id, state.agent.alaia_id, state.agent.external_id);
      state.agency = await agency.getAgencyByID(state.agent.office_id);

      setDetailLanguageLink(state.agent, getAgentLink);
      const { name, address, city, province, postal_code } = state.agent;
      const description = `${name} ${address} ${city} ${province} ${postal_code}`;
      set_title(`${description} | ${__('Royal LePage Commercial')}`);
      add_meta(description);
      add_link('canonical', agent_url);
      add_link('alternate', agent_url, 'en');
      add_link('alternate', getAgentLink(agent, 'fr'), 'fr');

      app.run('/setComponentState', state);
      app.run('/setInqueryComponentState', { inqueryTitle: <InqueryTitle agent1={state.agent} agent2='' />, email: state.agent.email, inquiryType: 'AgentInquiry', form_type: 'AgentProfile', agent1: state.agent });

      return state;
    },

    'image-failed': (state) => {
      state.agent.photoPath = '/images/missing-agent.jpg';
      return state;
    },
  };
}

new agentDetailProfile().start('.agent-profile-wrap');
new PropertyListing().start('#property-list');
new Charts().start('#agent-stats-chart');
new AgentAbout().start('#agent-about');
new InquiryForm().start('.sidebar-wrap');
new InquiryForm({ isPopup: true }).start('.mobile-property-form .modal-body');
